import { render, staticRenderFns } from "./LaudoOcorrenciaLote.vue?vue&type=template&id=c37fa896&"
import script from "./LaudoOcorrenciaLote.vue?vue&type=script&lang=js&"
export * from "./LaudoOcorrenciaLote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports